import { Controller } from "@hotwired/stimulus"

// window.ltCpbHelpers (app/assets/javascripts/lt_cpb_helpers.js) is the shared quantity stepper.
// It is Angular/Stimulus-shared code, out of this controller's scope to edit, and its own `init`
// calls `.find()`/`.val()`/`.text()`/`.on()` on the object it's handed -- it requires a jQuery
// object, so `$(this.formTarget)` stays jQuery too.
//
// Two bindings stay on jQuery rather than becoming data-actions:
// - the quantity input's "change", so it always runs after ltCpbHelpers' own change binding
//   (registered first, inside its init) that rounds a typed value up to the nearest 50; a native
//   listener would race it.
// - the `.current-payment-method` click, because payment_method_controller.js auto-selects a newly
//   added card with jQuery's synthetic `.click()`, which no native listener would see.
export default class extends Controller {
  static get targets() { return ["form", "tableQuantity", "tableTotal", "next"]; }
  static get values() { return { reorder: Boolean, pricePerUnit: Number }; }

  connect() {
    if (this.reorderValue) {
      window.ltCpbHelpers.init($(this.formTarget), this.pricePerUnitValue);
    }

    this.onQuantityChange = () => this.syncTableCells();
    $(this.formTarget).find("#quantity-ordered").on("change.customPackagingPayment", this.onQuantityChange);

    this.onPaymentMethodClick = (event) => {
      // Prevent the dropdown button from triggering this
      if (event.target.closest("button") !== null) {
        return;
      }

      // .payment-method-widget / .current-payment-method and their "id"/"active" state are
      // rendered by the shared payment_method_component partial, consumed by prepayment,
      // payment-method, give-payment and this controller across 9+ views -- not this
      // controller's own markup, so the dataset read and the class names stay hard-coded
      // (no Values/Targets/Classes API attribute belongs on shared, cross-controller markup).
      const target = event.currentTarget;
      this.paymentMethodIdField.value = target.dataset.id;
      this.element.querySelectorAll(".payment-method-widget").forEach((el) => el.classList.remove("active"));
      target.parentElement.classList.add("active");
      this.updateSubmitButton();
    };
    $(this.element).on("click.customPackagingPayment", ".current-payment-method", this.onPaymentMethodClick);
  }

  disconnect() {
    $(this.formTarget).find("#quantity-ordered").off("change.customPackagingPayment", this.onQuantityChange);
    $(this.element).off("click.customPackagingPayment", ".current-payment-method", this.onPaymentMethodClick);
  }

  increaseQuantityOrdered() {
    window.ltCpbHelpers.increaseQuantityOrdered();
    this.syncTableCells();
  }

  decreaseQuantityOrdered() {
    window.ltCpbHelpers.decreaseQuantityOrdered();
    this.syncTableCells();
  }

  nextStep(event) {
    event.preventDefault();
    this.formTarget.requestSubmit();
  }

  syncTableCells() {
    this.tableQuantityTarget.textContent = window.ltCpbHelpers.getQuantityOrdered();
    this.tableTotalTarget.textContent = window.ltCpbHelpers.getTotalPrice();
    this.updateSubmitButton();
  }

  get paymentMethodIdField() {
    return this.formTarget.querySelector("#custom_packaging_bundle_payment_method_id");
  }

  submittable() {
    const paymentMethodSelected = this.paymentMethodIdField.value !== "";

    if (this.reorderValue) {
      return paymentMethodSelected && window.ltCpbHelpers.getQuantityOrdered() >= 50;
    }

    return paymentMethodSelected;
  }

  updateSubmitButton() {
    const enabled = this.submittable();

    // "btn-disabled" is the app-wide disabled-button idiom (D1: 45 files under app/ lib/), not a
    // class this controller owns, so it stays a hard-coded literal rather than a Classes API entry.
    this.nextTargets.forEach((button) => {
      if (enabled) {
        button.disabled = false;
        button.classList.remove("btn-disabled");
      } else {
        button.disabled = true;
      }
    });
  }
}
